<template lang="pug">
.main
  el-tabs.theme(v-model="tabAtual")
    el-tab-pane(
      label='Tipos de Processos',
      name='TIPO_PROCESSO',
    )
      .conteudo-container
        el-table.table(
          :data="dadosWithColor"
        )
          template(slot="empty")
            | Nenhum processo encontrado.
          el-table-column(
            label="%",
            prop="nome"
            width="100"
            :formatter="porcentagem"
          )
          el-table-column(
            label="Tipos de Processos",
            prop="label",
            align="left",
            width="220"
          )
          el-table-column(
            label="Quantidade de Processos",
            prop="valor"
            align="center",
          )
            template(slot-scope="scope")
              div.tabela
                .content-tabela(:style="`--color: ${scope.row.color}`")
                  span {{ scope.row.valor }}
        app-plotly.grafico(nomeDiv="graficoProcessoEmAnalise", :dados="graficoDados", :layout="layout", :centralizarGrafico="true")
      span.total-processos Total de processos: {{totalDados}}
    el-tab-pane(
      label='Setores',
      name='SETORES',
    )
      grafico-processos-setor
</template>

<script>
import AppPlotly from '@/components/AppPlotly.vue'
import _ from 'lodash'
import { mapActions } from 'vuex'
import { colors } from '@/utils/constantes'
import GraficoProcessosSetor from './GraficoProcessoSetor'

export default {
  components: {
    AppPlotly,
    GraficoProcessosSetor
  },

  async created () {
    this.dadosLabels = await this.getListaProcessosCadastrados('EM_ANALISE')
  },

  data () {
    return {
      loading: true,
      tabAtual: 'TIPO_PROCESSO',
      dadosLabels: []
    }
  },

  computed: {
    dadosWithColor () {
      if (!this.dadosLabels) {
        return []
      }
      return this.dadosLabels.map((dado, index) => ({
        ...dado,
        color: colors[index]
      }))
    },

    graficoDados () {
      if (_.isEmpty(this.dadosLabels)) {
        return []
      }

      const graficoDados = [{
        values: [],
        labels: [],
        domain: { column: 0 },
        name: 'Processos Processos Em análise',
        hoverinfo: 'label+percent',
        textinfo: 'none',
        hole: 0.58,
        type: 'pie',
        marker: {
          colors: []
        }
      }]

      this.dadosWithColor.forEach((dado) => {
        graficoDados[0].labels.push(dado.label)
        graficoDados[0].values.push(dado.valor)
        graficoDados[0].marker.colors.push(dado.color)
      })

      return graficoDados
    },
    hasData () {
      return !_.isEmpty(this.dados)
    },
    layout () {
      return {
        showlegend: false,
        width: 280,
        height: 300,
        annotations: [
          {
            font: {
              size: 20
            },
            showarrow: false,
            text: this.totalDados,
            x: 0.5,
            y: 0.5
          }
        ]
      }
    },
    totalDados () {
      return this.dadosLabels.reduce((total, dado) => total + dado.valor, 0)
    }
  },
  methods: {
    ...mapActions({
      getListaProcessosCadastrados: 'dashboardRelatorios/getListaProcessosCadastrados'
    }),
    porcentagem (row) {
      return ((row.valor * 100) / this.totalDados).toFixed(2)
    }
  }
}
</script>
<style lang="scss" scoped>
.main {
  padding: 0 20px;
}

.total-processos {
  color: #92959a !important;
  font-size: 20px;
}

.conteudo-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

@media (max-width: 780px) {
  .conteudo-container {
    flex-direction: column;
  }
}

.table {
  width: 70%;
  flex: unset;
}

.grafico {
  width: auto !important;
}

.tabela {
  display: flex;
  justify-content: center;
  color: white;

  .content-tabela {
    width: 72px;
    background-color: var(--color);
  }
}

.el-tabs--border-card {
  border-bottom: 0;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  font-size: 16px;
  height: auto;
}

.radioButton {
  display: flex;
  justify-content: center;
}

/deep/ .el-tabs__item {
  color: #3498db;
}

/deep/ .el-tabs__active-bar {
  background-color: #3498db;
}

</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/gerais/ConteudoModalTotalProcessosEmAnalise.vue